import { Box, Button, TextField, IconButton, InputAdornment, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostDatosProductosTejidos } from "../../services/productosTejidos.services";
import ModalCharge from "../../modal/modalCharge";
import MenuItem from '@mui/material/MenuItem';
import imageCompression from "browser-image-compression";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl'; 
import { PostAmoxarifado } from "../../services/amoxarifado.services";
import ModalCategoriasAmoxarifado from "../../modal/amoxarifado/modalCategorias";
import ModalSubCategoriasAmoxarifado from "../../modal/amoxarifado/modalSubCategorias";
import { useDropzone } from "react-dropzone";
import CloseIcon from "@mui/icons-material/Close";
import ModalDepositoAmoxarifado from "../../modal/amoxarifado/modalDeposito";
import ModalEstante from "../../modal/estante/modalEstante";
import ModalFilaGetOne from "../../modal/fila/modalFilaOneMul";
import ModalEstanteGetOne from "../../modal/estante/modalEstantegetOne";
import ModalColumnaGetOne from "../../modal/columna/modalColumnagetOne";
import { Switch } from "@mui/material";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import secureStorage from "../../utils/secureStorage";






// const SOCKET_URL = 'http://localhost:5004/'; // URL del servidor Socket.IO
// const socket = io(SOCKET_URL, {
//   withCredentials: true,
//   transports: ["websocket", "polling"],
//   query: {
//     token: secureStorage.getItem("authToken"), // Pasar el token al conectarse
//   },
// });

const ProductosAmoxarifado = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isModalCategoriaOpen, setIsModalCategoriaOpen] = useState(false);
  const [isModalDepositoOpen, setIsModalDepositoOpen] = useState(false);
  const [isModalEstanteOpen, setIsModalEstanteOpen] = useState(false);
  const [isModalFilaOpen, setIsModalFilaOpen] = useState(false);
  const [isModalColumnaOpen, setIsModalColumnaOpen] = useState(false);
  const [estanteSeleccionado, setEstanteSeleccionado] = useState(null);
  const [depositoSeleccionado, setDepositoSeleccionado] = useState(null);
  const [filaSeleccionado, setFilaSeleccionado] = useState(null);
  const [columnaSeleccionado, setColumnaSeleccionado] = useState(null);
  const [serieEnabled, setSerieEnabled] = useState(true);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [subcategoriaSeleccionada, setSubcategoriaSeleccionada] = useState(null);
  const [isModalSubcategoriaOpen, setIsModalSubcategoriaOpen] = useState(false);
  const [idCategoriaActual, setIdCategoriaActual] = useState(null);
  const [imageBase64, setImageBase64] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [tipo, setTipo] = useState("");
  const [descuento, setDescuento] = useState("");
  const [droppedItems, setDroppedItems] = useState([]);
  const [dropError, setDropError] = useState('');

  const resetUbicacion = (setFieldValue) => {
  setEstanteSeleccionado(null);
  setFilaSeleccionado(null);
  setColumnaSeleccionado(null);
  setFieldValue("id_estante", "");
  setFieldValue("fila", "");
  setFieldValue("id_ubicacion", "");
};


  const ubicacionFinal =
  depositoSeleccionado && estanteSeleccionado && filaSeleccionado && columnaSeleccionado
    ? `${depositoSeleccionado.deposito} - ${estanteSeleccionado.descripcion} - ${filaSeleccionado.descripcion} - ${columnaSeleccionado.descripcion}`
    : "";
  

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const USER = secureStorage.getItem('id');
    const uploadedPaths = await uploadDroppedImages(droppedItems);

    const { producto, cod, cant_min, serie, imagen, id_subcategoria, id_ubicacion, costo} = values;

    const valuesToSend = {
        producto: producto.toUpperCase(),
        cod: cod.toUpperCase(),
        serie,
        cant_min: parseInt(cant_min),
        imagen: uploadedPaths.join(';'),
        id_categoria: id_subcategoria,
        id_ubicacion,
        costo
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await PostAmoxarifado(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
      setDepositoSeleccionado(null);
      setEstanteSeleccionado(null);
      setFilaSeleccionado(null);
      setColumnaSeleccionado(null);
      setCategoriaSeleccionada(null);
      setSubcategoriaSeleccionada(null);
      setIdCategoriaActual(null);
      setDroppedItems([]);
      setImageBase64("");
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleDrop = (acceptedFiles) => {
  const newItems = acceptedFiles.map((file) => ({
    name: file.name,
    preview: URL.createObjectURL(file),
    file, // Guardar el archivo original
  }));
  setDroppedItems((prevItems) => [...prevItems, ...newItems]);
  setDropError(''); // Limpiar el error cuando se agregan archivos
};

const handleRemoveItem = (index) => {
  setDroppedItems((prevItems) => prevItems.filter((_, i) => i !== index));
};

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    onDrop: handleDrop,
  });

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleImageChange = async (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        const formData = new FormData();
        formData.append("image", compressedFile);

        const response = await fetch(`${getApiBaseUrl()}upload`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          setFieldValue("imagen", data.filePath);
          setImageBase64(data.filePath);
        } else {
          console.error("Error al subir la imagen");
        }
      } catch (error) {
        console.error("Error al comprimir la imagen:", error);
      }
    }
  };

  const uploadDroppedImages = async (items) => {
  const uploadedImagePaths = [];

  for (const item of items) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(item.file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);

      const response = await fetch(`${getApiImagen()}/upload`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        uploadedImagePaths.push(data.filePath); // ← almacena las rutas
      } else {
        console.error("Error al subir la imagen", item.name);
      }
    } catch (error) {
      console.error("Error al comprimir/subir la imagen:", error);
    }
  }

  return uploadedImagePaths;
};


  return (
    <Box m="20px">
      <Header title="Registro Productos" subtitle="Registrar Productos" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={() => setRegistrationError(false)}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          producto: "",
          cod: "",
          cant_min: "",
          fila: "",
          serie: "",
          columna: "",
          imagen: "",
          id_categoria: "",
          id_subcategoria: "",
          id_ubicacion: "",
          serieEnabled: true,
          costo: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <>
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Marca"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.producto}
                name="producto"
                error={!!touched.producto && !!errors.producto}
                helperText={touched.producto && errors.producto}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nombre del Producto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.cod}
                name="cod"
                error={!!touched.cod && !!errors.cod}
                helperText={touched.cod && errors.cod}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Cantidad Mínima"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.cant_min}
                name="cant_min"
                error={!!touched.cant_min && !!errors.cant_min}
                helperText={touched.cant_min && errors.cant_min}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                label="Ubicación"
                name="id_ubicacion"
                value={ubicacionFinal || ""}
                onClick={() => setIsModalDepositoOpen(true)}
                InputProps={{ readOnly: true }}
                sx={{ gridColumn: "span 2", cursor: "pointer" }}
                error={!!touched.id_ubicacion && !!errors.id_ubicacion}
                helperText={touched.id_ubicacion && errors.id_ubicacion}
              />
              <TextField
                fullWidth
                variant="filled"
                label="Categoría"
                name="id_subcategoria"
                value={subcategoriaSeleccionada?.subcategoria || ""}
                onClick={() => setIsModalCategoriaOpen(true)}
                InputProps={{ readOnly: true }}
                sx={{ gridColumn: "span 2", cursor: "pointer" }}
                error={!!touched.id_subcategoria && !!errors.id_subcategoria}
                helperText={touched.id_subcategoria && errors.id_subcategoria}
              />
              <Box display="flex" alignItems="center" sx={{ gridColumn: "span 2", cursor: "pointer" }}>
                <Switch
                  checked={values.serieEnabled}
                  onChange={() => {
                    const nuevoValor = !values.serieEnabled;
                    setFieldValue("serieEnabled", nuevoValor);
                    if (!nuevoValor) {
                      setFieldValue("serie", "");
                    }
                  }}
                    sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "rgb(206, 220, 0)",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgb(206, 220, 0)",
                  }
                }}
                />
                <TextField
                fullWidth
                variant="filled"
                label="Nº de serie"
                value={values.serie}
                onChange={handleChange}
                onBlur={handleBlur}
                name="serie"
                disabled={!values.serieEnabled}
                sx={{ gridColumn: "span 1", cursor: "pointer" }}
                error={!!touched.serie && !!errors.serie}
                helperText={touched.serie && errors.serie}
              />

              </Box>
              <TextField
                fullWidth
                variant="filled"
                label="Costo"
                name="costo"
                value={values.costo || ""}
                onBlur={handleBlur}
                onChange={handleChange}
                sx={{ gridColumn: "span 2", cursor: "pointer" }}
                error={!!touched.costo && !!errors.costo}
                helperText={touched.costo && errors.costo}
              />

              {values.imagen && (
                <Box sx={{ gridColumn: "span 4" }}>
                  <img
                    src={values.imagen}
                    alt="Vista previa"
                    style={{ width: "100%", height: "auto", marginTop: "10px" }}
                  />
                </Box>
              )}
            </Box>
            <Box mt={4}>
              <Typography variant="h6">
                Arrastra y suelta los items aquí:
              </Typography>
        
              <Box
                {...getRootProps()}
                sx={{
                  border: "2px dashed #cccccc",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: isDragActive
                    ? "rgb(206, 220, 0)"
                    : "transparent",
                  height: isDragActive ? "200px" : "100px", // Ajuste de altura basado en isDragActive
                  transition: "height 0.3s ease-in-out", // Transición suave para el cambio de altura
                }}
              >
                <input {...getInputProps()} />
                <Typography sx={{ fontSize: isDragActive ? "1.5rem" : "1rem" }}>
                  {isDragActive
                    ? "Suelte aquí su archivo"
                    : "Arrastra y suelta las fotos aquí, o haz clic para seleccionar archivos"}
                </Typography>
              </Box>
              {dropError && <Typography color="error">{dropError}</Typography>}
              <Box
                mt={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #cccccc",
                  borderRadius: "5px",
                }}
              >
                {droppedItems.map((item, index) => (
                  <Box
                    key={index}
                    mt={2}
                    sx={{ padding: "1vh", alignItems: "center" }}
                  >
                    <Typography sx={{ marginLeft: "5vh" }}>
                      • {item.name}
                    </Typography>
                    <IconButton
                      onClick={() => handleRemoveItem(index)}
                      size="small"
                      sx={{ marginLeft: "1vh" }}
                    >
                      <CloseIcon />
                    </IconButton>
                    <img src={item.preview} alt={item.name} width="100px" />
                  </Box>
                ))}
              </Box>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#bac609" },
                }}
              >
                Registrar
              </Button>
            </Box>
            <ModalCharge isLoading={isLoading} />
          </form>
          <ModalDepositoAmoxarifado
            open={isModalDepositoOpen}
            onClose={() => setIsModalDepositoOpen(false)}
            onSelect={(deposito) => {
              setFieldValue("id_dep", deposito.id); 
              setDepositoSeleccionado(deposito); 
              resetUbicacion(setFieldValue);    // Guardar el depósito
              setIsModalDepositoOpen(false);         // Cerrar modal de depósito
              setIsModalEstanteOpen(true);           // Abrir modal de estante
            }}
          />
          <ModalEstanteGetOne
            open={isModalEstanteOpen}
            onClose={() => setIsModalEstanteOpen(false)}
            idDeposito={depositoSeleccionado?.id}
            nombreDeposito={depositoSeleccionado?.deposito} 
            onSelect={(estante) => {
              setFieldValue("id_estante", estante.id);
              setEstanteSeleccionado(estante);
              setIsModalEstanteOpen(false);
              setIsModalFilaOpen(true);               // Abrimos modal de fila
            }}
          />
          <ModalFilaGetOne
            open={isModalFilaOpen}
            onClose={() => setIsModalFilaOpen(false)}
            idEstante={estanteSeleccionado?.id}
            nombreEstante={estanteSeleccionado?.descripcion}
            onSelect={(fila) => {
              setFieldValue("fila", fila.fila);
              setFilaSeleccionado(fila);
              setIsModalFilaOpen(false);
              setIsModalColumnaOpen(true);
            }}
          />
          <ModalColumnaGetOne
            open={isModalColumnaOpen}
            onClose={() => setIsModalColumnaOpen(false)}
            idFila={filaSeleccionado?.id}
            nombreFila={filaSeleccionado?.descripcion}
            onSelect={(columna) => {
              setFieldValue("id_ubicacion", columna.id);
              setColumnaSeleccionado(columna);
              setIsModalColumnaOpen(false);
            }}
          />
          <ModalCategoriasAmoxarifado
            open={isModalCategoriaOpen}
            onClose={() => setIsModalCategoriaOpen(false)}
            onSelect={(categoria) => {
              setCategoriaSeleccionada(categoria);
              setFieldValue("id_categoria", categoria.id);
              setIdCategoriaActual(categoria.id);
              setIsModalCategoriaOpen(false);
              setIsModalSubcategoriaOpen(true);
            }}
          />
          <ModalSubCategoriasAmoxarifado
            open={isModalSubcategoriaOpen}
            onClose={() => setIsModalSubcategoriaOpen(false)}
            idCategoria={idCategoriaActual} 
            nombreCategoria={categoriaSeleccionada?.categoria}
            onSelect={(subcategoria) => {
              setSubcategoriaSeleccionada(subcategoria);                     
              setFieldValue("id_subcategoria", subcategoria.id); 
              setIsModalSubcategoriaOpen(false);
            }}
          />

        </>

        )}
        
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
    producto: yup.string().required("La marca es requerido"),
    cod: yup.string().required("El código del producto es requerido"),
    cant_min: yup
    .number()
    .typeError("La cantidad mínima debe ser un número")
    .required("Cantidad es requerida")
    .positive("Solo números positivos"),
    id_subcategoria: yup.number().required("Este campo es requerido"),
    id_categoria: yup.number().required("Este campo es requerido"),
    id_ubicacion: yup.number().required("Este campo es requerido"),
    serie: yup.mixed().when("serieEnabled", {
      is: true,
      then: () => yup.string().required("La serie es requerida"),
      otherwise: () => yup.string().notRequired(),
    }),

    // serieEnabled: yup.boolean(),
    costo: yup.number()
    .typeError("El costo debe ser un número")
    .positive("Solo se acepta números positivos")
    .required("Este campo es requerido")
});

export default ProductosAmoxarifado;